import React from 'react';

export interface OrderedOption {
  index: number;
  label: string;
  image?: string;
  category?: string;
}

interface OptionCardProps {
  option: OrderedOption;
  disabled?: boolean;
  selected?: boolean;
  onSelect: (opt: OrderedOption) => void;
}

export function OptionCard({ option, onSelect, disabled, selected }: OptionCardProps) {
  return (
    <button
      type="button"
      className="ww-option-card"
      onClick={() => { if (!disabled) onSelect(option); }}
      disabled={disabled}
      aria-label={option.label}
      data-selected={selected ? 'true' : 'false'}
    >
      <div className="ww-option-card-image">
        {option.image ? (
          <img src={option.image} alt={option.category || option.label} loading="lazy" />
        ) : (
          <div className="ww-option-card-image--placeholder" />
        )}
      </div>
      <div className="ww-option-card-content">
        {option.category ? (
          <div className="ww-option-card-category">{option.category}</div>
        ) : null}
        <div className="ww-option-card-label">{option.label}</div>
      </div>
    </button>
  );
}


